import { render } from "./Void.vue?vue&type=template&id=7bd337fc&scoped=true"
import script from "./Void.vue?vue&type=script&lang=js"
export * from "./Void.vue?vue&type=script&lang=js"

import "./Void.vue?vue&type=style&index=0&id=7bd337fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd337fc"]])

export default __exports__